import { services } from '@/data/services';
import { ServiceCard } from '@/components/ui/ServiceCard';
import { SectionHeading } from '@/components/ui/SectionHeading';

type Props = {
  excludeSlug: string;
};

export function RelatedServices({ excludeSlug }: Props) {
  const related = services.filter((s) => s.slug !== excludeSlug);
  return (
    <section className="px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-surface">
      <div className="mx-auto max-w-[1440px] flex flex-col gap-10">
        <SectionHeading eyebrow="While you are here" title="Explore the rest" />
        <div className="grid gap-6 md:grid-cols-2">
          {related.map((s) => (
            <ServiceCard
              key={s.slug}
              title={s.title}
              tagline={s.tagline}
              href={`/services/${s.slug}`}
              illustration={s.illustration}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
